/** Releases the sticky breadcrumb once .bq-accordions-section scrolls up to meet it. */
(function () {
  var crumb = document.querySelector('.shopify-section:has(> .bq-breadcrumb)');
  var acc = document.querySelector('.bq-accordions-section');
  if (!crumb || !acc) return;

  var squeeze = window.matchMedia('(min-width: 990px)');
  function target() {
    return (squeeze.matches && document.querySelector('.page-wrapper')) || document;
  }

  var ticking = false;
  function update() {
    ticking = false;
    var limit = crumb.getBoundingClientRect().height + 10;
    crumb.classList.toggle('is-released', acc.getBoundingClientRect().top < limit);
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  var bound = null;
  function bind() {
    if (bound) bound.removeEventListener('scroll', onScroll);
    bound = target();
    bound.addEventListener('scroll', onScroll, { passive: true });
    update();
  }
  bind();
  squeeze.addEventListener('change', bind);
})();
